import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { caixaService } from '../services';

const CaixaContext = createContext(null);

export function CaixaProvider({ children }) {
  const [caixaAberto, setCaixaAberto] = useState(null); // null = carregando
  const [loading, setLoading] = useState(true);

  const recarregar = useCallback(async () => {
    try {
      const { data } = await caixaService.atual();
      setCaixaAberto(!!data?.aberto);
    } catch {
      // Em caso de erro de rede, não bloqueia indevidamente
      setCaixaAberto(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { recarregar(); }, [recarregar]);

  return (
    <CaixaContext.Provider value={{ caixaAberto, loading, recarregar }}>
      {children}
    </CaixaContext.Provider>
  );
}

export function useCaixa() {
  const ctx = useContext(CaixaContext);
  if (!ctx) throw new Error('useCaixa deve ser usado dentro de CaixaProvider');
  return ctx;
}
